import { HttpStatusCode } from "axios";

import { alertConstants } from "../../helper/sweet-alert";
import ButtonService from "../../apiServices/masters/buttonService";
import { IButtonData } from "../../models/master/buttons";
import { setButton, setButtons } from "../../store/slices/master/buttonSlice";

export function getButton(id: number) {
  return async function (dispatch: any, getState: any) {
    let response = await ButtonService.getButton(id);
    if (response?.success === true) {
      dispatch(setButton(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getAllButtons(
  configUserRole?: number,
  pageBlockId?: number,
  collegeId?: number,
  noOfItems?: number
) {
  return async function (dispatch: any, getState: any) {
    let response = await ButtonService.getAllButtons(
      configUserRole,
      pageBlockId,
      collegeId,
      noOfItems
    );
    if (response?.success === true) {
      dispatch(setButtons(response.data));
    } else {
      console.log("error");
    }
  };
}

export function createButton(data: IButtonData, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await ButtonService.createButton(data);
    const name = data.name
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict, name);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateButton(
  data: IButtonData,
  id: number,
  callback: Function
) {
  return async function (dispatch: any, getState: any) {
    let response = await ButtonService.updateButton(data, id);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateButtonPriority(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await ButtonService.updateButtonPriority(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      callback(alertConstants.error);
    }
  };
}

export function deleteButton(id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await ButtonService.deleteButton(id);
    if (response === true) {
      callback(alertConstants.inactiveSuccess);
    } else {
      callback(alertConstants.inactiveFailure);
    }
  };
}
